import { Pipe, PipeTransform } from '@angular/core';
import { BasePremiumActivity } from '../../types/premium-activity.type';

@Pipe({
  standalone: true,
  name: 'lxSelectedPremiumActivities',
})
export class SelectedPremiumActivitiesPipe implements PipeTransform {
  transform(selectedPremiumActivities: BasePremiumActivity[]): string {
    if (!selectedPremiumActivities) {
      return '';
    }

    if (selectedPremiumActivities.length === 1) {
      return $localize`1 premium selected`;
    }

    return $localize`${selectedPremiumActivities?.length} premiums selected`;
  }
}
